import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const FilterIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "filter",
  "FilterIcon",
  ["currentColor"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><path d="M2.79639 2.66669H13.2038V4.58623L10.1297 7.17671V13.3334H5.87046V7.17671L2.79639 4.58623V2.66669ZM4.16986 4.00002L7.20379 6.55667V12H8.7964V6.55667L11.8303 4.00002H4.16986Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g></svg>
);

export default FilterIcon;
